import { render, staticRenderFns } from "./CompStackChartPanel.vue?vue&type=template&id=a20b8e54&scoped=true"
import script from "./CompStackChartPanel.vue?vue&type=script&lang=js"
export * from "./CompStackChartPanel.vue?vue&type=script&lang=js"
import style0 from "./CompStackChartPanel.vue?vue&type=style&index=0&id=a20b8e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20b8e54",
  null
  
)

export default component.exports